import React from "react"
import styled from "styled-components"
import StyledSmallTitle from "../styled/styledSmallTitle"
import Title from "../Title"
import Paragraph from "../styled/styledParagraph"
import CollapsedOffer from "./CollapsedOffer"

const StyledParagraph = styled(Paragraph)`
  color: #fff;
  @media (min-width: 1024px) {
    font-size: 20px;
    line-height: 32px;
  }
`

const StyledSection = styled.section`
  background-color: #000;
  padding: 48px 16px;
  /* prettier-ignore */
  ${StyledParagraph}:nth-of-type(3) {
    margin: 29px 0 16px;
  }
  & div.box {
    @media (min-width: 768px) {
      width: 576px;
      margin: 0 auto;
    }
    @media (min-width: 1024px) {
      width: auto;
    }
  }
  @media (min-width: 1024px) {
    padding: 80px 16px 283px;
  }
  @media (min-width: 1800px) {
    padding: 120px 16px 283px;
  }
`
const Container = styled.div`
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 65px;
    justify-content: space-between;
    max-width: 900px;
    margin: 0 auto;
  }
  @media (min-width: 1200px) {
    max-width: 1200px;
    grid-column-gap: 130px;
  }
`
const OurSuperpowers = () => {
  return (
    <StyledSection>
      <Container>
        <div className="box">
          <StyledSmallTitle>Nasze Supermoce</StyledSmallTitle>
          <Title light>
            Skupiamy się na dostarczaniu
            <br /> <span>cyfrowych produktów i usług.</span>
          </Title>
          <StyledParagraph>
            Kompleksowo zajmiemy się wszystkimi potrzebami Twojego
            przedsiębiorstwa. Genialne strony internetowe, doskonale
            przeprowadzone kampanie reklamowe, czy skrupulatne badania rynku?
          </StyledParagraph>
          <StyledParagraph>
            Zespół Nis Media zapewni Ci najnowsze i skuteczne rozwiązania w
            każdej z tych dziedzin.
          </StyledParagraph>
        </div>
        <div className="box">
          <CollapsedOffer />
        </div>
      </Container>
    </StyledSection>
  )
}

export default OurSuperpowers
